import { useTranslation } from 'react-i18next';

export default function BrainMeetPrivacyPage() {
  const { t } = useTranslation();
  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 24px", fontFamily: "sans-serif", lineHeight: 1.7, color: "#1a1a1a" }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>{t('brain.meet_privacy.page_title')}</h1>
      <p style={{ color: "#666", marginBottom: 32 }}>{t('brain.meet_privacy.last_updated')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_overview_title')}</h2>
      <p>{t('brain.meet_privacy.section_overview_text')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_data_title')}</h2>
      <p>{t('brain.meet_privacy.section_data_intro')}</p>
      <ul>
        <li dangerouslySetInnerHTML={{ __html: t('brain.meet_privacy.section_data_item1') }} />
        <li dangerouslySetInnerHTML={{ __html: t('brain.meet_privacy.section_data_item2') }} />
        <li dangerouslySetInnerHTML={{ __html: t('brain.meet_privacy.section_data_item3') }} />
      </ul>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_usage_title')}</h2>
      <p>{t('brain.meet_privacy.section_usage_intro')}</p>
      <ul>
        <li>{t('brain.meet_privacy.section_usage_item1')}</li>
        <li>{t('brain.meet_privacy.section_usage_item2')}</li>
        <li>{t('brain.meet_privacy.section_usage_item3')}</li>
      </ul>
      <p>{t('brain.meet_privacy.section_usage_footer')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_sharing_title')}</h2>
      <p>{t('brain.meet_privacy.section_sharing_text')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_retention_title')}</h2>
      <p>{t('brain.meet_privacy.section_retention_text')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_audience_title')}</h2>
      <p>{t('brain.meet_privacy.section_audience_text')}</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32 }}>{t('brain.meet_privacy.section_contact_title')}</h2>
      <p dangerouslySetInnerHTML={{ __html: t('brain.meet_privacy.section_contact_text') }} />

      <p style={{ marginTop: 48, color: "#999", fontSize: 13 }}>
        {t('brain.meet_privacy.footer')}
      </p>
    </div>
  );
}
